import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ManageMainMenuPermissionsWidget from '../../../widgets/managePermissions/ManageMainMenuPermissionsWidget'
import ManageProcessPermissionsWidget from '../../../widgets/managePermissions/ManageProcessPermissionsWidget'
import { getManagePermissions } from '../../../redux/actions/adminProjectManagemant'

export default function ManagePermissions() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManagePermissions()
      if (response) {
        setSchema(response?.model)
      } else {
        setError({})
      }

      // setSchema(mock)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isManagement>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {schema?.forms?.mainMenuPermission && (
        <>
          <ManageMainMenuPermissionsWidget schema={schema.forms.mainMenuPermission} />
          <br />
        </>
      )}

      {schema?.forms?.processPermission && (
        <>
          <ManageProcessPermissionsWidget schema={schema.forms.processPermission} />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
